import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';

export class PublicLayout extends Component {
    static displayName = PublicLayout.name;
    constructor(props) {
        super(props);
        this.backgroundImage = this.getBackgroundImage();
    }

    getBackgroundImage() {
        var imageIndex = (Math.floor(Math.random() * 9) + 1).toString().substr(-2);
        var indexPadding = 2 - imageIndex.length;
        var imageString = '/images/bg_site_' + ('0' * indexPadding) + imageIndex + '.jpg';
        return imageString;
    }

    render() {
        const style = {
            backgroundImage: 'url("' + this.backgroundImage + '")',
            backgroundSize: 'cover',
            height: '100%'
        }
        return (
            <div className="col-md-12 col-md-offset-6 loginFormWrapperContainer" style={style} >
                <div className="loginFormWrapper">
                    <div className="loginFormContent">
                        <img src="/images/logo_phoenix_red.png" className="logo-main-login" title="My Phoenix" alt="Phoenix" />
                        <Outlet />
                        <div className="logo-footer-container">
                            <img src="/logo_tcoe_black_md.png" title="Tulare County Office of Education" className="logo-footer-small" alt="TCOE" /><br/>
                            <label>Ver. 1.1.3</label>
                        </div>
                    </div>
                </div>
            </div> 
        );
    }
}
